export var KafkaSecurityProtocol;
(function (KafkaSecurityProtocol) {
    KafkaSecurityProtocol["KAFKA_SECURITY_PROTOCOL_PLAINTEXT"] = "PLAINTEXT";
    KafkaSecurityProtocol["KAFKA_SECURITY_PROTOCOL_SSL"] = "SSL";
    KafkaSecurityProtocol["KAFKA_SECURITY_PROTOCOL_SASL_PLAINTEXT"] = "SASL_PLAINTEXT";
    KafkaSecurityProtocol["KAFKA_SECURITY_PROTOCOL_SASL_SSL"] = "SASL_SSL";
})(KafkaSecurityProtocol || (KafkaSecurityProtocol = {}));
